<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'duplicate-modal.duplicate-element'">Duplicar elemento</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__form-container">
    <div class="common-container__mandatory-obligatory-message-form">
      <span class="common-tag__mandatory-text-asterisk">*</span>
      <span class="common-tag__mandatory-label-text-obligatory-message"
        [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
    </div>
    <field-type-text-simple [field]="duplicateModal.nameElement"
      [preSelectItem]="duplicateModal.name"
      (itemSelected)="itemSelected($event)">
    </field-type-text-simple>
    <div class="common-switch__col-container">
      <field-type-switch [field]="{label: 'duplicate-modal.preserve-content'|afTranslate}"
        [small]="true"
        [preSelectItem]="duplicateModal.copydata"
        (itemSelected)="duplicateModal.copydata = $event.newValue">
      </field-type-switch>
      <field-type-switch [field]="{label: 'duplicate-modal.keep-reference'|afTranslate}"
        [small]="true"
        [preSelectItem]="duplicateModal.copyreference"
        (itemSelected)="duplicateModal.copyreference = $event.newValue">
      </field-type-switch>
    </div>
  </div>
  <div class="duplicate-modal__body-container">
    <div class="duplicate-modal__body-header-container"
      [afTranslate]="'duplicate-modal.select-location-new-element'">_Selecciona una ubicación para el nuevo elemento</div>
    <div class="common-branch-tree__body-items-container">
      <div class="common-branch-tree__body-inner-items-container">
        <div class="common-branch-tree__col-header-item-container">
          <div class="common-branch-tree__space-button-sm"></div>
          <div class="common-button__block-button-md-checkbox">
            <button class="common-button__icon-md-checkbox"
              [ngClass]="{'common-button__icon-md-checkbox--selected': duplicateModal.selectedEvaluation}"
              [disabled]="type === 'concept'"
              (click)="productSelected()">
              <i class="common-icon__md"
                [ngClass]="duplicateModal.selectedEvaluation?'lf-icon-radio-button-active':'lf-icon-step-first'"></i>
            </button>
          </div>
          <div class="common-branch-tree__item-container"
            [ngClass]="{'common-branch-tree__item-container--disabled': type === 'concept'}">
            <i class="lf-icon-hamburger-menu common-icon__md"></i>
            <span>{{duplicateModal.productName}}</span>
          </div>
        </div>
        @for (evaluation of evaluationList; track $index) {
          <div class="common-branch-tree__col-item-container">
            @if(evaluation.children?.length){
              <button class="common-button__icon-sm-noborder"
                (click)="evaluation.show = !evaluation.show">
                <i class="common-icon__md"
                  [ngClass]="evaluation.show?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
              </button>
            }@else {
              <div class="common-branch-tree__space-button-sm"></div>
            }
            <div class="common-button__block-button-md-checkbox">
              <button class="common-button__icon-md-checkbox"
                [ngClass]="{'common-button__icon-md-checkbox--selected': evaluation.selected}"
                (click)="optionSelected(evaluation)">
                <i class="common-icon__md"
                  [ngClass]="evaluation.selected?'lf-icon-radio-button-active':'lf-icon-step-first'"></i>
              </button>
            </div>
            <div class="common-branch-tree__item-container">
              <i [class]="evaluation.icon + ' common-icon__md'"></i>
              <span>{{evaluation.name}}</span>
            </div>
          </div>
          @if (evaluation.show) {
            <branch-tree class="common-branch-tree__container-children"
              [childrenList]="evaluation.children"
              [product]="duplicateModal.product"
              [type]="'duplicate'"
              [level]="1"
              (selectChildrenEmit)="selectChildrenOn($event)">
            </branch-tree>
          }
        }
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="checkName()">
      <span class="common-button__text-title"
        [afTranslate]="'common.duplicate'">_Duplicar</span>
    </button>
  </div>
</div>
